module.exports = __webpack_public_path__ + "src/assets/img/antispamsystem.19eb1834.jpg";